<app-card header="{{ title }}">
    <gms-loading-spinner [loading$]="isLoading$"></gms-loading-spinner>
    <div [ngClass]="{'container': !(execludeTsp$ | async)}">
        @if(execludeTsp$ | async){
        <gms-error-and-notice-panel [mainMessage]="errorMessage"></gms-error-and-notice-panel>
        }@else{
        @if(notices$ | async; as data){
        <ng-container>
            @for (notice of data; track notice.noticeID){
            <div class="row">
                <span class="date">{{ notice.dateTimeNoticeEffective | date: 'MM/dd/yyyy' }}</span>
                <span class="value"
                      (click)="downloadData(notice.noticeID)">{{ notice.subject }}</span>
            </div>
            }
        </ng-container>
        }
        }
    </div>
</app-card>